/** @format */

import React from 'react';
import { FACTS_FIELD_KEYS } from '../utilities';
import './styles.scss';
import { checkIfValueIsValid } from '../common';

export const getEnvironmentData = (props) => {
  const { dataSet, objectText } = props;

  const factKey = FACTS_FIELD_KEYS.ENVIRONMENT;

  const environmentData = dataSet[factKey] || {};

  // environmentData.areaSource = dataSet?.baseInfo?.areaSource;
  environmentData.areaSourceComment = dataSet?.baseInfo?.areaSourceComment;

  const EnvironmentFactsRow = ({ facts }) => {
    const factFieldName = facts?.factFieldName;
    if (checkIfValueIsValid(facts?.value)) {
      return (
        <div className='object-listing-accordian-list object-listing-accordian-list-no-border'>
          <div className='object-listing-accordian-list-left'>
            {objectText?.[`${factKey}Obj`]?.[factFieldName]?.label ||
              objectText?.[factKey]?.[factFieldName]?.label ||
              facts?.factFieldName}
          </div>
          <div className='object-listing-accordian-list-right'>
            {facts?.value}
          </div>
        </div>
      );
    }

    return <></>;
  };

  let fields = [
    <EnvironmentFactsRow
      key='marketingArea'
      facts={{
        factFieldName: 'marketingArea',
        value: dataSet?.baseInfo?.address?.area
      }}
    />
  ];

  Object.keys(environmentData).forEach((fieldKey, index) => {
    if (checkIfValueIsValid(environmentData[fieldKey])) {
      fields.push(
        <EnvironmentFactsRow
          key={index}
          facts={{
            factFieldName: fieldKey,
            value: environmentData[fieldKey]
          }}
        />
      );
    }
  });

  const EnvironmentSection = () => {
    return <div className='environment-data-body'>{fields}</div>;
  };

  return {
    component: <EnvironmentSection />,
    factsCount: fields.length
  };
};
